import getSliceName from '@om-fe/core/utils/get-slice-name';
import {
    PARTICIPANT_MATCH_AGGREGATOR_PATH,
    PARTICIPANT_MATCH_AGGREGATOR_PATH_LOGGED_IN,
    ParticipantMatchListTopic,
    slicePrefix,
} from './participant-match-list.constants';
import { getMatchListNrOfMarkets } from '@om-fe/core/components/match-list/utils/match-list.utils';
import * as shallowEqual from 'shallowequal';
import { ParticipantMatchListPublicProps } from './participant-match-list';
import { DisciplineLiveStatus } from '@om-fe/models';
import getConfig, { OMFE2ConfigModel } from '@om-fe/core/utils/config';

export function getParticipantMatchListSliceName(instanceId: string): string {
    return getSliceName(slicePrefix, instanceId);
}

export function getParticipantMatchListTopic(
    participantId: string,
    liveStatus?: DisciplineLiveStatus,
    mainMarketsLimit?: number,
): ParticipantMatchListTopic {

    const nrOfMarkets: number = getMatchListNrOfMarkets(mainMarketsLimit);
    const globalConfig: OMFE2ConfigModel = getConfig();
    const isAuthenForTopic: boolean = !!globalConfig?.enabledTopicDelay;
    const topic: string = isAuthenForTopic ? PARTICIPANT_MATCH_AGGREGATOR_PATH_LOGGED_IN : PARTICIPANT_MATCH_AGGREGATOR_PATH;

    return {
        path: topic,
        params: {
            participantId,
            liveStatus,
            nrOfMarkets,
        },
    };
}

interface ParticipantMatchListTopicProps {
    readonly participantId: string;
    readonly liveStatus?: DisciplineLiveStatus;
    readonly mainMarketsLimit: number | undefined;
}

const getTopicProps = (props: ParticipantMatchListPublicProps): ParticipantMatchListTopicProps => ({
    participantId: props.participantId,
    liveStatus: props.liveStatus,
    mainMarketsLimit: props.mainMarketsLimit,
});

export function areParticipantMatchListTopicPropsEqual(
    prevProps: ParticipantMatchListPublicProps,
    newProps: ParticipantMatchListPublicProps,
): boolean {
    return shallowEqual(getTopicProps(prevProps), getTopicProps(newProps));
}
